import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dnp-sharepoint',
  template: `
    <p>
      sharepoint works!
    </p>
  `,
  styles: []
})
export class SharepointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
